import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const unlockInstPage = (data: { pageId: string }): Promise<void> => {
  return axios.post('/meta/pages/unlock', data);
};

type UnlockInstPageOptions = {
  config?: MutationConfig<typeof unlockInstPage>;
};

export function useUnlockInstPage({ config = {} }: UnlockInstPageOptions = {}) {
  return useMutation<void, AxiosError<{ error: string }>, { pageId: string }>({
    onSuccess: () => {
      toasts.loadingToast.success('unlock-inst-page', 'Page unblocked successfully');
      queryClient.invalidateQueries(['instagram-blocked-pages']);
    },
    onError: (error) => {
      toasts.loadingToast.error('unlock-inst-page', error.response?.data?.error);
    },
    onMutate: () => {
      toasts.loadingToast.loading('unlock-inst-page', 'Unblocking page...');
    },
    ...config,
    mutationFn: unlockInstPage,
  });
}
